var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"custom-btn",class:[_vm.variantClass, _vm.disabledClass],style:(_vm.styles),attrs:{"depressed":"","disabled":_vm.disabled,"loading":_vm.loading,"to":_vm.to},domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }